import 'windi.css'
import './common/style/mixin.less'
import { createApp } from 'vue'
import 'vant/lib/index.css'
import {
  ActionBar,
  ActionBarIcon,
  ActionBarButton,
  Divider,
  Popup,
  Overlay,
  Loading,
  Dialog,
  ContactCard,
  Form,
  AddressEdit,
  AddressList,
  Field,
  CellGroup,
  Cell,
  SwipeCell,
  Icon,
  Stepper,
  Card,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Button,
  Swipe,
  SwipeItem,
  PullRefresh,
  List,
  Tab,
  Tabs,
  SubmitBar,
  Toast,
  Skeleton,
  Picker,
  Uploader,
  Lazyload,
  Empty,
  Image,
  Sticky,
  Col,
  Row,
  DatePicker,
  TimePicker,
  PickerGroup,
  CountDown,
  Popover,
  Watermark
} from 'vant'
import App from './App.vue'
import router from './router'
import 'lib-flexible/flexible'
import 'vant/lib/index.css' // 全局引入样式
import '@/assets/iconfont/iconfont.js'
import Vconsole from 'vconsole'
import { createPinia } from 'pinia'
const app = createApp(App) // 创建实例
export { app }
if (process.env.NODE_ENV != 'production') {
  const vConsole1 = new Vconsole()
  app.use(vConsole1)
}
console.log(process.env.NODE_ENV)
// 全局过滤器
app.config.globalProperties.$filters = {
  prefix(url) {
    if (url && url.startsWith('http')) return url
    else return `https://i.xurl.cn${url}`
  }
}

// 全局积分名称变量
app.config.globalProperties.integralName = ''

app
  .use(ActionBarButton)
  .use(ActionBarIcon)
  .use(ActionBar)
  .use(Divider)
  .use(Popup)
  .use(Overlay)
  .use(Loading)
  .use(Dialog)
  .use(Toast)
  .use(ContactCard)
  .use(Form)
  .use(AddressEdit)
  .use(AddressList)
  .use(Field)
  .use(CellGroup)
  .use(Cell)
  .use(SwipeCell)
  .use(Icon)
  .use(Stepper)
  .use(Card)
  .use(Button)
  .use(Swipe)
  .use(SwipeItem)
  .use(PullRefresh)
  .use(List)
  .use(Tab)
  .use(Tabs)
  .use(SubmitBar)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Radio)
  .use(RadioGroup)
  .use(Skeleton)
  .use(Picker)
  .use(Uploader)
  .use(Lazyload)
  .use(Empty)
  .use(Image)
  .use(Sticky)
  .use(Col)
  .use(Row)
  .use(DatePicker)
  .use(TimePicker)
  .use(PickerGroup)
  .use(CountDown)
  .use(Popover)
  .use(Watermark)

app.use(router)
app.use(createPinia())

process.env.VUE_APP_MOCK && require('../mock/index')

app.mount('#app')
